import React from "react";
import { reportError } from "../lib/errorReporter";
import { t } from "../lib/theme";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try {
      reportError({
        kind: "react",
        message: error?.message || String(error),
        stack: error?.stack || "",
        extra: { componentStack: info?.componentStack || "" },
      });
    } catch {
      /* never break the boundary */
    }
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div
        style={{
          minHeight: "100vh",
          background: t.bgGrad,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 28,
          textAlign: "center",
          gap: 16,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
      >
        <div
          style={{
            width: 84,
            height: 84,
            borderRadius: 999,
            background: t.primaryGrad,
            color: "#FFF",
            fontSize: 38,
            fontWeight: 800,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: t.shadow,
          }}
        >
          !
        </div>
        <div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: t.ink,
              letterSpacing: "-0.01em",
            }}
          >
            Something went sideways
          </div>
          <div
            style={{
              fontSize: 13,
              color: t.inkSoft,
              marginTop: 8,
              fontWeight: 500,
              maxWidth: 320,
              lineHeight: 1.5,
            }}
          >
            We logged it for the dev team. Try again or reload the app.
          </div>
        </div>
        <details
          style={{
            background: t.surface,
            borderRadius: 14,
            padding: 12,
            maxWidth: 360,
            width: "100%",
            textAlign: "left",
            boxShadow: t.shadowSoft,
            fontSize: 11,
            color: t.inkSoft,
          }}
        >
          <summary style={{ cursor: "pointer", fontWeight: 700 }}>
            Show error
          </summary>
          <div
            style={{
              marginTop: 8,
              fontFamily:
                "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 200,
              overflow: "auto",
            }}
          >
            {error.message}
            {"\n\n"}
            {error.stack}
          </div>
        </details>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={this.reset}
            style={{
              all: "unset",
              cursor: "pointer",
              padding: "12px 22px",
              borderRadius: 14,
              background: t.surface,
              color: t.inkSoft,
              fontSize: 13,
              fontWeight: 700,
              boxShadow: t.shadowSoft,
            }}
          >
            Try again
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{
              all: "unset",
              cursor: "pointer",
              padding: "12px 22px",
              borderRadius: 14,
              background: t.primaryGrad,
              color: "#FFF",
              fontSize: 13,
              fontWeight: 800,
              boxShadow: t.shadow,
            }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
